import React from 'react';
import { ConfidenceRanking } from 'abbot-core';
import voAudio from '../../assets/vo/U1-T2-3-2.mp3';
import img from '../../assets/images/U1-T2-3-2.svg';

const question = 'I know how important nutritious food choices are to my health.';

const vo = {
  sources: [
    {
      src: voAudio
    }
  ],
  transcript: (
    <p>
      At the beginning of the module, we asked if you knew how important making nutritious food choices is to your health. Select the image that matches how you feel now.
    </p>
  )
};

export default {
  title: 'Confidence Ranking',
  path: '/reflect/confidence',
  content: <ConfidenceRanking vo={vo} question={question} image={img} />
};



// WEBPACK FOOTER //
// ./src/data/reflect/ConfidenceRanking.js